import React, { Fragment } from 'react';
import { Table, Button } from 'antd';
import _cloneDeep from 'lodash/cloneDeep';
import { groupTypeMapArr } from 'utils/enum/state-enum.js';

export default class ShowTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tableData: _cloneDeep(props.sourceData),
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      tableData: _cloneDeep(nextProps.sourceData),
    });
  }

  handleDelete(rowData) {
    this.props.onDelUser(rowData);
  }

  handleClick() {
    this.props.onAddUser();
  }

  render() {
    const columns = [
      {
        title: '学校',
        dataIndex: 'schoolName',
      },
      {
        title: '分组',
        dataIndex: 'groupType',
        render: val => {
          const status = groupTypeMapArr.find(q => q.key === val);
          return status ? status.value : val;
        },
      },
      {
        title: '年级',
        dataIndex: 'lastDepartName',
      },
      {
        title: '班级',
        dataIndex: 'curDepartName',
      },
      {
        title: '姓名',
        dataIndex: 'name',
        width: 80,
      },
      {
        title: '操作',
        width: 50,
        render: rowData => {
          return (
            <Fragment>
              <a onClick={this.handleDelete.bind(this, rowData)}>删除</a>
            </Fragment>
          );
        },
      },
    ];
    const { tableData } = this.state;

    return (
      <div>
        <div style={{ marginBottom: '24px' }}>
          <Button type="primary" onClick={this.handleClick}>
            新增人员
          </Button>
        </div>
        <Table
          size="small"
          columns={columns}
          dataSource={tableData}
          rowKey="id"
          pagination={{ pageSize: 10 }}
          // scroll={{ y: 240 }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_business/Address/ShowTable/Index.js